// UserPassTemplateコンポーネントをインポート
// ユーザー向けの「パスワード変更」ページ用テンプレートとして使用
import UserPassTemplate from "../templates/UserPassTemplate";

/**
 * UserPassPageコンポーネント
 * ユーザー向けの「パスワード変更」ページを表示するためのコンポーネント
 * UserPassTemplateを利用して、パスワード変更画面を構築
 */
const UserPassPage = () => {

    // パスワード変更ページテンプレートをレンダリング
    // 特別なプロパティを渡さず、UserPassTemplateをそのまま利用
    return (
        <UserPassTemplate />
    );
}

// UserPassPageコンポーネントをデフォルトエクスポート
// 他のファイルからこのコンポーネントをインポートして利用可能にする
export default UserPassPage;
